import { Service } from "./Service";
import { CountryBasedSubscriptionService } from "./CountryBasedSubscriptionService";
import { CustomPricedService } from "./CustomPricedService";
import { HourlyService } from "./HourlyService";
import { OssSubscriptionService } from "./OssSubscriptionService";
import { SimpleService } from "./SimpleService";
import { SubscriptionService } from "./SubscriptionService";
export class ServiceFactory {
  static create($type) {
    if ($type === "V1.Orders.Create.Request.Service") {
      const result = new Service();
      return result;
    }
    if ($type === "V1.Orders.Create.Request.CountryBasedSubscriptionService") {
      const result = new CountryBasedSubscriptionService();
      return result;
    }
    if ($type === "V1.Orders.Create.Request.CustomPricedService") {
      const result = new CustomPricedService();
      return result;
    }
    if ($type === "V1.Orders.Create.Request.HourlyService") {
      const result = new HourlyService();
      return result;
    }
    if ($type === "V1.Orders.Create.Request.OssSubscriptionService") {
      const result = new OssSubscriptionService();
      return result;
    }
    if ($type === "V1.Orders.Create.Request.SimpleService") {
      const result = new SimpleService();
      return result;
    }
    if ($type === "V1.Orders.Create.Request.SubscriptionService") {
      const result = new SubscriptionService();
      return result;
    }
    throw new Error($type + " not found");
  }
}
